<template>
  <el-form @submit.native.prevent>
    <el-form-item class="mb-0">
      <el-input
        v-model="e"
        placeholder="E.g. jane.smith@example.com"
        clearable
      />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    e: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
